import TablaConciliacion from "../../../TablaConciliacion";

function TablaViadelosllanos() {
  return <TablaConciliacion nombreUseCase="viadelosllanos" titulo="VIA DE LOS LLANOS" />;
}

export default TablaViadelosllanos;
